import { Component } from '@cms-max/medicare-api-sdk'
import { useMemo } from 'react'
import { CoreUnderivedEventData } from '../core'
import { TealiumUnderivedEventData } from '../tealium'
import { useLegacyEvent, UseLegacyEventConfig, UseLegacyEventConfigGeneric } from './useLegacyEvent'

export type UseChatEventConfig = UseLegacyEventConfigGeneric<Omit<CoreUnderivedEventData, 'property' | 'component'>, TealiumUnderivedEventData>

/**
 *
 * @param options
 * @returns an event with the core property defaulted to MAX and core component defaulted to Header
 */
export const useLegacyChatEvent = (options: UseChatEventConfig) => {
  const eventFactoryConfig = useMemo(() => {
    const config: UseLegacyEventConfig = {}
    if (options.core) {
      config.core = {
        property: 'MAX',
        component: Component.LiveChat,
        ...options.core
      }
    }
    if (options.tealium) {
      config.tealium = options.tealium
    }

    return config
  }, [options])

  const createEvent = useLegacyEvent(eventFactoryConfig)
  return createEvent
}
